import { createReducer } from '@reduxjs/toolkit';

import { loadFiltersListSuccess, loadFiltersStart } from './actions';
import { IFilterData, IUsersReducer } from './types';

const initialState: IUsersReducer = {
  isLoading: false,
  isLoaded: false,
  data: {} as IFilterData,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadFiltersStart, (state) => ({ ...state, list: { ...state, isLoading: true } }))
    .addCase(loadFiltersListSuccess, (state, action) => ({
      ...state,
      data: action.payload,
    }));
});
